import { TSeoFaqItem } from '@/entities/catalog-old/types/type'

import { TSeoResponse } from '@/shared/types/deprecated-types'

export enum FilterPropertyType {
	Number = `N`,
	List = `L`
}

export enum FilterJsonType {
	Price = `><`,
	Default = `=`
}

export enum FilterDisplayType {
	RangeWithSlider = `A`,
	Range = `B`,
	CheckBox = `F`,
	CheckBoxWithPicture = `G`,
	CheckBoxWithLabelAndPicture = `H`,
	Radio = `K`,
	Select = `P`,
	SelectWithLabelAndPicture = `R`
}

export enum SortType {
	PopularityToLow = `popular`,
	PriceLowToHigh = `price|asc`,
	PriceHighToLow = `price|desc`,
	NewFirst = `date|asc`
}

export type FilterValue = {
	CHECKED?: boolean
	FILTERED_VALUE?: number
	ELEMENT_COUNT: number
	SORT: number
	VALUE: string | number
	ID: string
	NAME?: string
}

export type FilterProperties = {
	CODE: string
	DISPLAY_EXPANDED: boolean
	DISPLAY_TYPE: `${FilterDisplayType}`
	FILTER_HINT: string
	ID: string
	NAME: string
	DISABLED?: boolean
	PROPERTY_TYPE: `${FilterPropertyType}`
	VALUES: FilterValue[]
}

export type FilterData = {
	FILTER_URL_SEF?: string
	PROPERTIES: FilterProperties[]
	SEO: TSeoResponse
	FAQ: TSeoFaqItem[]
}

// Step filter ("пошаговый фильтр") — a lightweight, ordered subset of properties returned by
// index/catalog/step-filter/{code}. The response `data` is the properties array directly (no
// PROPERTIES/SEO/FAQ wrapper). Each property carries SELECTED to mark an already-picked step;
// the first property with SELECTED === false is the current active step.
export type StepFilterValue = {
	ID: string
	NAME?: string
	ELEMENT_COUNT: number
	CHECKED: boolean
	VALUE: string | number
}

export type StepFilterProperty = {
	ID: number
	CODE: string
	NAME: string
	// Ready-to-render accusative prompt from the backend ("Выберите серию"). Replaces the former
	// client-side declension dictionary — just render it as the active-step label.
	NAME_HINT: string
	FILTER_HINT: string
	SELECTED: boolean
	VALUES: StepFilterValue[]
}

export type FilterJsonProperties = {
	[key: string]: {
		type: FilterJsonType
		value: (string | number)[]
	}
}
